import React, { useState } from "react";
import { Collapse, Icon } from "antd";
import { CollapseProps } from "antd/es/collapse";
import { ChapterType, SourceType } from "API/courseware";
import CoursewareItem from "../CoursewareItem";
import classNames from "classnames";
import styles from "./index.module.scss";

interface ChapterNodeProps extends CollapseProps {
    title: React.ReactNode;
    indent?: number;
    chapters: ChapterType[];
    sources: SourceType[];
}

export default function ChapterNode({
    title,
    chapters,
    sources,
    indent = 0
}: ChapterNodeProps) {
    const [collapse, setCollapse] = useState<boolean>(false);

    return (
        <Collapse
            defaultActiveKey="1"
            className={classNames(styles.root, styles[`level${indent}`])}
            onChange={keys => setCollapse(keys.length === 0)}
            expandIcon={() => (
                <Icon
                    type={collapse ? "caret-right" : "caret-down"}
                    style={{ color: "#bbb" }}
                />
            )}>
            <Collapse.Panel key="1" header={title}>
                {chapters.map(item => (
                    <ChapterNode
                        key={item.id}
                        indent={indent + 1}
                        title={item.chapterName}
                        chapters={item.children || []}
                        sources={item.dcCoursewareSourceList || []}
                    />
                ))}

                {sources.map(item => (
                    <CoursewareItem key={item.id} data={item} indent={indent} />
                ))}
            </Collapse.Panel>
        </Collapse>
    );
}
